import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { environment } from '../../../environments/environment';
import { RbacAccessResponse } from '../../../types/generated/rbacAccessResponse';
import { RbacService } from '../../core/services/rbac.service';

export const rbacGuard = (
  permissionKey: keyof RbacAccessResponse,
): CanActivateFn => {
  return () => {
    const rbacService = inject(RbacService);
    const router = inject(Router);
    const isBankerIQEnabled = environment.featureToggles.enableBankerIQ;

    return rbacService.getUserAccess().pipe(
      map((accessRights) => {
        if (
          permissionKey === 'bankerIQAuthorizationStatus' &&
          !isBankerIQEnabled
        ) {
          return router.createUrlTree(['/']);
        }
        if (accessRights && accessRights[permissionKey]) {
          return true;
        }
        return router.createUrlTree(['/login-failed']);
      }),
      catchError(() => of(router.createUrlTree(['/login-failed']))),
    );
  };
};
